import Vue from 'vue'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import Quill from 'quill'

import htmlEditButton from "quill-html-edit-button";

Quill.register('modules/htmlEditButton', htmlEditButton)

Vue.use(VueQuillEditor)

export default VueQuillEditor